import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { PromotionListItem } from './PromotionListItem'
import { Carousel } from 'shared/UI/Carousel'
import sortBy from 'lodash/sortBy'

const PromotionItemsCarousel = (props) => {

  const renderPromotionItems = () => {
    return sortBy(props.items, 'key').map((item, index) =>
      <PromotionListItem
        showIcons={props.showIcons}
        key={index}
        item={item}
        themeColorHex={props.themeColorHex}
        textAlignmentClass={props.textAlignmentClass}
        iconSizeClass={props.iconSizeClass}/>
    )
  }

  return (
    <div className={`promotion-items carousel-container ${props.alignmentClass}`}>
      <Carousel
        themeColorHex={props.themeColorHex}
        isLooped={true}
        numberOfItemsPerSlide={props.numberOfItemsPerSlide}>
        {renderPromotionItems()}
      </Carousel>
    </div>
  )
}

PromotionItemsCarousel.propTypes = {
  themeColorHex: PropTypes.string.isRequired,
  items: PropTypes.object,
  showIcons: PropTypes.bool.isRequired,
  numberOfItemsPerSlide: PropTypes.number.isRequired,
  textAlignmentClass: PropTypes.string,
  iconSizeClass: PropTypes.string
}

PromotionItemsCarousel.defaultProps = {
  numberOfItemsPerSlide: 1,
}

export default PromotionItemsCarousel
